import { useParams, useNavigate, useLocation } from "react-router-dom";
import HeaderPreRegistration from "../../Components/HeaderPreRegistration";

const PreRegistrationFinished = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { name, locationID, bookingReference } = location.state || {};

  return (
    <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
      <HeaderPreRegistration bookingReference={bookingReference}/>

      <div className="w-4/5 sm:w-full mx-auto">
        <h1 className="text-3xl mt-6 text-center Kallisto_Bold">
          Thank You {name}!
        </h1>

        <h2 className="mt-8 text-xl md:text-2xl text-[#c7c7c7] font-kallisto mb-12 max-w-xl Kallisto_Bold text-center mx-auto">
          Your details have been submitted successfully. See you at Ballerz!
        </h2>

        <h2 className="text-xl md:text-2xl text-[#c7c7c7] font-kallisto mb-12 max-w-xl Kallisto_Bold text-center mx-auto">
          If you want to add another player to your booking, click the button
          below. If not, you can close this page.
        </h2>

        <div className="flex flex-col sm:flex-row justify-center gap-4 sm:w-auto">
          <button
            onClick={() =>
              navigate("/pre-registration/email", {
                state: {
                  locationID,
                  bookingReference,
                },
              })
            }
            className="bg-[#3F50F6] hover:bg-[#2d3fcc] py-4 px-2 rounded flex items-center justify-center w-full sm:w-[250px] gap-4"
          >
            <span className="text-white Kallisto_Bold font-bold whitespace-nowrap">
              Another Player
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreRegistrationFinished;
